module.exports = __webpack_public_path__ + "img/3855502.jpeg";